export const ROLE_ADMIN = 'Administrátor';
export const ROLE_TEACHER = 'Učiteľ';
export const ROLE_STUDENT = 'Študent';
export const ROLE_EXTERNAL_PARTNER = 'Externý partner FRI';
export const ROLE_EXTERNAL_USER = 'Externý používateľ';
export const ROLE_DEPARTMENT_HEAD = 'Vedúci pracoviska';
export const ROLE_DEPARTMENT_DEPUTY = 'Zástupca vedúceho pracoviska';
export const ROLE_DEPARTMENT_SECRETARY = 'Sekretariát';
export const ROLE_DEPARTMENT_RESERVATION_RESPONSIBLE = 'Zodpovedný pracoviska za rezervácie miestností';
export const ROLE_STUDY_PROGRAMS_ADMIN = 'Administrátor študijných programov';
export const ROLE_STUDY_PROGRAM_GUARANTEE = 'Garant študijného programu';
export const ROLE_POOLS_ADMIN = 'Administrátor ankiet';
export const ROLE_EXTERNAL_PARTNERS_ADMIN = 'Administrátor externých partnerov FRI';
export const ROLE_EXTERNAL_USERS_ADMIN = 'Administrátor externých používateľov';
export const ROLE_ROOM_RESERVATIONS_ADMIN = 'Administrátor rezervácií miestností';
export const ROLE_FRI_JOBS_EXTERNAL_PARTNER = 'Externý partner FRI.jobs';
export const ROLE_FRI_JOBS_ADMIN = 'Administrátor FRI.jobs';
export const ROLE_FRI_JOBS_STUDENT = 'Študent FRI.jobs';
export const ROLE_FRI_OPEN_ADMIN = 'Administrátor FRI.open';
export const ROLE_FRI_OPEN_PARTICIPANT = 'Účastník FRI.open';
export const ROLE_FRI_OPEN_LECTURER = 'Lektor FRI.open';
export const ROLE_FRI_EDU_PATRICIPANT = 'Účastník FRI.edu';
export const ROLE_FRI_EDU_LECTURER = 'Lektor FRI.edu';
export const ROLE_FRI_EDU_ADMIN = 'Administrátor FRI.edu';
export const ROLE_METEO_ADMIN = 'Administrátor meteorologickej stanice';
export const ROLE_ERASMUS_COORDINATOR = 'Koordinátor Erasmus';
export const ROLE_ERASMUS_STUDENT = 'Študent Erasmus';
export const ROLE_FRI_INTERNAL_JOBS_ADMIN = 'Administrátor FRI.prax';
export const ROLE_FRI_INTERNAL_JOBS_LECTURER = 'Lektor FRI.prax';
export const ROLE_FRI_INTERNAL_JOBS_INTERN = 'Praktikant FRI.prax';
export const ROLE_QUIZ_ADMIN = 'Administrátor kvízov';
export const ROLE_PHD_COMMISSION = 'Člen komisie PhD';
export const ROLE_PHD_FIELD_COMMISSION_WORKING_GROUP_CHAIR = 'Predseda pracovnej skupiny odborovej komisie';
export const ROLE_PHD_FIELD_COMMISSION_WORKING_GROUP_MEMBER = 'Člen pracovnej skupiny odborovej komisie';
export const ROLE_PHD_ADMIN = 'Administrátor PhD štúdia';
export const ROLE_PHD_STUDENT = 'Študent PhD';
export const ROLE_PHD_SUPERVISOR = 'Školiteľ PhD';
export const ROLE_PHD_EXTERNAL_SUPERVISOR = 'Externí školiteľ PhD';

export const ROLE_ING_PROJECTS_ADMIN = 'Administrátor inžinierskych projektov';
export const ROLE_ING_PROJECTS_GUARANTOR = 'Garant inž. projektu';
export const ROLE_ING_PROJECTS_ASSIGNMENT_COORDINATOR = 'Koordinátor priradenia inž. projektov';
export const ROLE_ING_PROJECT_STUDENT = 'Študent projektovej výučby';

export const ROLE_ATTENDANCE_ADMIN = 'Administrátor prezenčných listín';
export const ROLE_ATTENDANCE_CREATOR = 'Tvorca prezenčných listín';
export const ROLE_ATTENDANCE_PARTICIPANT = 'Evidovaný účastník v prezenčnej listine';

export const ROLE_WIKI_ADMIN = 'Administrátor FRI.wiki';
export const ROLE_WIKI_AUTHOR = 'Autor FRI.wiki';

export const DEPARTMENT_FUNCTION_DEAN = 'dekan';
export const DEPARTMENT_FUNCTION_VICE_DEAN_SCIENCE = 'prodveda';
export const DEPARTMENT_FUNCTION_VICE_DEAN_EDUCATION = 'prodvzd';
export const DEPARTMENT_FUNCTION_VICE_DEAN_INTERNATIONAL = 'prodzahr';
export const DEPARTMENT_FUNCTION_FACULTY_SECRETARY = 'tajomnik';
export const DEPARTMENT_FUNCTION_PHD_AND_CAREER_OFFICE = 'vedaref';
export const DEPARTMENT_FUNCTION_PERSONNEL_OFFICE = 'persref';
export const DEPARTMENT_FUNCTION_STUDY_OFFICE = 'studref';
export const DEPARTMENT_FUNCTION_ECONOMIC_OFFICE = 'ekonref';
export const DEPARTMENT_FUNCTION_PROJECTS_AND_RELATIONS_OFFICE = 'sfreuref';

export const DEPARTMENT_FUNCTION_LABEL_DEAN = 'Dekan';
export const DEPARTMENT_FUNCTION_LABEL_VICE_DEAN_SCIENCE = 'Prodekan pre vedu a výskum';
export const DEPARTMENT_FUNCTION_LABEL_VICE_DEAN_EDUCATION = 'Prodekan pre vzdelávanie';
export const DEPARTMENT_FUNCTION_LABEL_VICE_DEAN_INTERNATIONAL = 'Prodekan pre zahraničné vzťahy';
export const DEPARTMENT_FUNCTION_LABEL_FACULTY_SECRETARY = 'Tajomník fakulty';
export const DEPARTMENT_FUNCTION_LABEL_PHD_AND_CAREER_OFFICE = 'Referát pre doktorandské štúdium a kariérny rast';
export const DEPARTMENT_FUNCTION_LABEL_PERSONNEL_OFFICE = 'Personálny referát';
export const DEPARTMENT_FUNCTION_LABEL_STUDY_OFFICE = 'študijný referát';
export const DEPARTMENT_FUNCTION_LABEL_ECONOMIC_OFFICE = 'Ekonomický referát';
export const DEPARTMENT_FUNCTION_LABEL_PROJECTS_AND_RELATIONS_OFFICE = 'Referát pre projekty a vonkajšie vzťahy';
